import React, { useState } from 'react';

const meetingAgentHtml = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>ZyunAgent SDK</title>
    <style>
      html, body {
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        min-height: 100%;
        overflow: hidden;
      }
      .container {
        width: 100%;
        height: 100%;
        min-height: 100%;
      }
      #zyun-agent-container {
        width: 100%;
        height: 100%;
        min-height: 100%;
      }
      #zyun-agent-container > *,
      #zyun-agent-container > * > *,
      #zyun-agent-container > * > * > * {
        width: 100% !important;
        height: 100% !important;
        min-height: 100% !important;
      }
      #zyun-agent-container iframe {
        width: 100% !important;
        height: 100% !important;
        min-height: 100% !important;
        border: 0 !important;
      }
    </style>
</head>
<body>
    <div class="container">
        <div id="zyun-agent-container"></div>
    </div>
</body>
<script src="https://s3.ssl.qhres2.com/!1fb2e7ce/VoiceText.js"></script>
<script src="https://s0.ssl.qhres2.com/!1133ab31/zagent.prod.20260409_105656.umd.js"></script>
<script>
    function stretchElement(el) {
        if (!el || !el.style) return;
        el.style.width = "100%";
        el.style.height = "100%";
        el.style.minHeight = "100%";
    }

    function forceFillHeight() {
        var container = document.getElementById("zyun-agent-container");
        if (!container) return;
        stretchElement(document.documentElement);
        stretchElement(document.body);
        stretchElement(container);
        stretchElement(container.firstElementChild);
        stretchElement(container.firstElementChild && container.firstElementChild.firstElementChild);
        stretchElement(
            container.firstElementChild &&
            container.firstElementChild.firstElementChild &&
            container.firstElementChild.firstElementChild.firstElementChild
        );
        var iframes = container.querySelectorAll("iframe");
        iframes.forEach(function(frame) {
            frame.style.width = "100%";
            frame.style.height = "100%";
            frame.style.minHeight = "100%";
            frame.style.border = "0";
        });
    }

    try {
        forceFillHeight();
        ZyunAgent.initZyunAgent("zyun-agent-container", {
            eqid: 'songdengju',
            service_id: '105311',
            chatType: 'chat'
        });
        setTimeout(forceFillHeight, 0);
        setTimeout(forceFillHeight, 300);
        setTimeout(forceFillHeight, 1000);
        window.addEventListener("resize", forceFillHeight);

        var observeTarget = document.getElementById("zyun-agent-container");
        if (observeTarget && typeof MutationObserver !== "undefined") {
            var observer = new MutationObserver(function() {
                forceFillHeight();
            });
            observer.observe(observeTarget, { childList: true, subtree: true });
        }
        console.log("ZyunAgent 初始化成功");
    } catch (error) {
        console.error("ZyunAgent 初始化失败:", error);
    }
</script>
</html>`;

const MeetingAgent: React.FC = () => {
  const [selectedProject, setSelectedProject] = useState('project-alpha');

  return (
    <div className="page-block meeting-agent-page">
      <div className="breadcrumb meeting-agent-breadcrumb">
        <span>会议智能体</span>
        <div className="meeting-agent-project-control">
          <span>项目</span>
          <select
            className="toolbar-select meeting-agent-project-select"
            aria-label="项目切换"
            value={selectedProject}
            onChange={(event) => setSelectedProject(event.target.value)}
          >
            <option value="project-alpha">项目 Alpha</option>
            <option value="project-beta">项目 Beta</option>
            <option value="project-gamma">项目 Gamma</option>
          </select>
        </div>
      </div>
      <div className="page-card meeting-agent-page-card">
        <div className="meeting-agent-embed">
          <iframe
            title="会议智能体"
            className="meeting-agent-iframe"
            srcDoc={meetingAgentHtml}
          />
        </div>
      </div>
    </div>
  );
};

export default MeetingAgent;
